import { Decoder } from '@msgpack/msgpack';

import { base64DecodeBinary } from '@canvas/encoding';

/**
 * Computes the default JSON messages which should be applied for a given
 * locale. Deliberately focuses on testing locales only, as the default
 * application fetches locales over network when initialising.
 * @returns
 */
export const getDefaultMessages = () => {
  const decoder = new Decoder();

  const locale = globalThis.window?.ATLASSIAN_CANVAS?.testingLocale;
  if (!locale) {
    return;
  }

  const locales = globalThis.window?.ATLASSIAN_CANVAS?.testingLocaleData;
  if (!locales) {
    return;
  }

  const localesBinary = base64DecodeBinary(locales);
  const localesDecoded = decoder.decode(localesBinary) as Record<
    string,
    Record<string, string>
  >;
  return localesDecoded[locale];
};
